import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Crea campagna di notifiche push',
  sent_title: 'Notifica in coda',
  sent_subtitle:
    'La tua notifica push è stata inviata ad Apple e Google. Le conferme di consegna arrivano in circa 15 minuti.',
  sent_info_banner:
    'Puoi chiudere questa finestra. Continueremo a verificare e aggiornare automaticamente le statistiche di consegna della campagna.',
  circles: {
    sent_label: 'Inviato',
    sent_sub: 'Inviato agli iscritti',
    delivered_label: 'Consegnato',
    delivered_sub: 'In attesa di Apple e Google',
    delivered_ready_short: 'Pronto',
    delivered_ready_sub: 'Aggiorna per vedere le ultime statistiche',
  },
  scheduled_title: 'Campagna pianificata',
  scheduled_body_line_1: 'La tua notifica push è pianificata per {{when}}.',
  scheduled_body_line_2:
    "La invieremo automaticamente a quell'ora. Le conferme di consegna da Apple e Google sono disponibili circa 15 minuti dopo l'invio.",
  recipients_count_one: 'Inviato a {{count}} iscritto.',
  recipients_count_other: 'Inviato a {{count}} iscritti.',
  close: 'Chiudi',
  sections: {
    message: 'Messaggio',
    audience: 'Pubblico',
    when: 'Quando inviare',
    review: 'Revisione',
  },
  stepper: {
    message: 'Messaggio',
    audience_when: 'Quando inviare',
    review: 'Revisione',
  },
  blocked_reasons: {
    title_required: 'Aggiungi un titolo per continuare.',
    body_required: 'Aggiungi il corpo del messaggio per continuare.',
    offer_required: "Seleziona un'offerta per continuare.",
    promo_code_required: 'Seleziona un codice promo per continuare.',
    send_option_required: 'Scegli quando inviare per continuare.',
    scheduled_at_required: 'Seleziona data e ora per continuare.',
  },
  fields: {
    title: {
      label: 'Titolo',
      placeholder: 'Inserisci il titolo della notifica',
    },
    body: {
      label: 'Corpo del messaggio',
      placeholder: 'Inserisci il tuo messaggio',
    },
    audience: {
      label: 'Pubblico',
    },
    send_options: {
      label: 'Opzioni di invio',
    },
    date_and_time: {
      label: 'Data e ora',
      placeholder: 'Seleziona data e ora',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Invia ora',
    [SendOptions.Schedule]: 'Pianifica',
  },
  send_option_cards: {
    now: {
      title: 'Invia ora',
      description: 'Invia subito a tutti gli iscritti.',
    },
    schedule: {
      title: 'Pianifica',
      description: "Seleziona una data e un'ora future.",
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promozionale 🚀',
      description: "Promuovi un'offerta o un codice promo.",
    },
    informational: {
      title: 'Informativo ℹ️',
      description: 'Condividi news o aggiornamenti — senza sconti allegati.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Tutti gli utenti ({{count}} dispositivo)',
  },
  preview: {
    title: 'Anteprima',
    notifications: {
      title: 'Il titolo della notifica apparirà qui',
      body: 'Il corpo del messaggio verrà visualizzato qui con tutti i dettagli...',
      now: 'Ora',
    },
    estimated_reach: 'Copertura',
  },
  summary: {
    title: 'Riepilogo',
    reach: 'Copertura',
    when: 'Quando',
    campaign_type: 'Tipo di campagna',
    promo_code: 'Codice promo',
    offer: 'Offerta',
    test_audience: 'Invia prima una notifica di test',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Limite giornaliero di invio raggiunto',
      description:
        "Attenzione! Inviare più di 1 notifica push al giorno rende gli utenti insoddisfatti e può portare alla disinstallazione dell'app. Per questo limitiamo gli invii manuali a 1/giorno. Pianifica per domani.",
    },
    offer_not_sendable: {
      title: "L'offerta non è attiva oggi",
      description: 'Scegli una data futura.',
    },
  },
  buttons: {
    send_now: 'Invia ora',
    save: 'Salva',
    save_as_draft: 'Salva come bozza',
    send_test: 'Invia test',
    draft_with_ai: 'Bozza con AI',
    back: 'Indietro',
    next: 'Avanti',
  },
  feedback: {
    success: 'Campagna salvata con successo',
    promo_code_expired: 'Codice promo scaduto',
    error: 'Impossibile salvare la campagna. Controlla la connessione e riprova.',
  },
};
